/**
 * External Imports
 */
import { FC, useMemo } from 'react';
import { useParams } from 'react-router-dom';

/**
 * Internal Imports
 */
import MyEmployeeListTable from '../../components/customTables/account/myEmployeeListTable';
import MyDelegatesListTable from '../../components/customTables/account/myDelegatesTable';
import DelegatedToMeTable from '../../components/customTables/account/delegatedToMeTable';
import AccountSideNav from '../../components/sideNav/accountSideNav/AccountSideNav';
import AdhocListTable from '../../components/customTables/account/adhocListTable/AdhocListTable';
import {
  CSCListSettingsTable,
  CNEdListSettingsTable,
  NLRListSettingsTable,
  AIDETListSettingsTable,
  BSSRListSettingsTable,
  SafetyListSettingsTable
} from '../../components/customTables/account/supportListSettingsTables';
import NoDataSplashView from '../../components/shared/table/noDataSplashView';

/**
 * Style Imports
 */
import { ContentContainer } from './Account.styles';

const EmployeeRoundingSettings: FC<{}> = () => {
  const { empRoundSettingsTable = 'employee-list' } = useParams();

  const currentlySelectedSettingsTable = useMemo(() => {
    switch (empRoundSettingsTable) {
      case 'employee-list':
        return <MyEmployeeListTable />;
      case 'delegate-list':
        return <MyDelegatesListTable />;
      case 'delegated-to-me':
        return <DelegatedToMeTable />;
      case 'adhoc-list':
        return <AdhocListTable />;
      case 'csc-list':
        return <CSCListSettingsTable />;
      case 'cned-list':
        return <CNEdListSettingsTable />;
      case 'nlr-validation-list':
        return <NLRListSettingsTable />;
      case 'aidet-validation-list':
        return <AIDETListSettingsTable />;
      case 'bssr-validation-list':
        return <BSSRListSettingsTable />;
      case 'safety-validation-list':
        return <SafetyListSettingsTable />;
      default:
        return <NoDataSplashView type="" />;
    }
  }, [empRoundSettingsTable]);

  return (
    <ContentContainer data-testid="employee-rounding-settings-view">
      <AccountSideNav />
      {currentlySelectedSettingsTable}
    </ContentContainer>
  );
};

export default EmployeeRoundingSettings;
